import { render, staticRenderFns } from "./AlumniPage.vue?vue&type=template&id=c588e9a6&scoped=true"
import script from "./AlumniPage.vue?vue&type=script&lang=js"
export * from "./AlumniPage.vue?vue&type=script&lang=js"
import style0 from "./AlumniPage.vue?vue&type=style&index=0&id=c588e9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c588e9a6",
  null
  
)

export default component.exports